import { saveAs } from 'file-saver';
import domToImage from 'dom-to-image-more';
import baseImageUrl from '../img/base.png';

export const downloadDomNodeAsImage = async (domNode, filename) => {
  const { width, height } = domNode.getBoundingClientRect();
  const imageAsBlob = await domNodeToImage(domNode, width, height);

  saveAs(imageAsBlob, filename);
};

const createImageElement = src =>
  new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve(image);
    image.onerror = error => reject(error);
    image.src = src;
  });
const canvasToBlob = canvas => new Promise(resolve => canvas.toBlob(resolve));

const domNodeToImage = async (domNode, width, height) => {
  const canvas = await domToImage.toCanvas(domNode);

  const baseImage = await createImageElement(baseImageUrl);
  const baseImageWidth = 400;
  const baseImageHeight = baseImageWidth / 4;

  const context = canvas.getContext('2d');
  context.drawImage(
    baseImage,
    width - baseImageWidth - 25,
    height - baseImageHeight - 25,
    baseImageWidth,
    baseImageHeight
  );

  return await canvasToBlob(canvas);
};
